module.exports = __webpack_public_path__ + "static/media/SK3.38b904b1.jpg";